import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { Loan } from '../../../../../gql/graphql';
import { LoanDetailContext } from '../../../Private';
import DropdownBlue from '../../../../../components/Dropdowns/Dropdown/Dropdown';

interface Props {
  loans: any[],
  entities: any[],
}

const CardEntitiesAndLoans = ({ loans, entities }: Props) => {

  const navigate = useNavigate();

  const { setLoan: setLoanSelected }: any = useContext(LoanDetailContext);


  const getLoansName = (loans: Loan[]) => {

    const selectLoan = (loanId: string) => {
      setLoanSelected(loans.find(item => item._id === loanId));
      navigate(`/loans/${loanId}`);
    }

    return (
      <>
        <DropdownBlue
          label={
            <>
              {`See all loans -->`}
            </>
          }
          items={loans?.map((item) => ({ key: item._id, label: item.name }))}
          onClickSelect={selectLoan}
          className={`dropdown-blue-bold`}
        />
      </>
    );
  }

  return (
    <div className='card-profile-generic'>
      <h1 className='card-title'>Entities and loans</h1>
      <div className='flex-btw mt-10'>
        <span className='title-bold'>
          <span className='bold'>{loans?.length}</span> {loans?.length === 1 ? 'loan' : 'loans'} | {' '}
          <span className='bold'>{loans?.length}</span> open
          {/*| <span className='bold'>2</span> closed*/}
        </span>
        {getLoansName(loans)}
      </div>
      <div className='flex-btw mt-10'>
        <span className='title-bold'>
          <span className='bold'>{entities?.length}</span> {entities?.length === 1 ? 'entity' : 'entities'}
        </span>
        {/*
          <Link className="body-regular link" to="./" onClick={() => openLink('entities')}>
            See all entities <img src={arrowBlue} alt='arrow' className='arrow' />
          </Link>
        */}
      </div>
    </div>
  )
}

export default CardEntitiesAndLoans